import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  content: {
    zIndex: 9,
    height: '100%',
    overflowY: 'scroll',
    padding: 15,
    display: 'flex',
    flexDirection: 'column',
    scrollBehavior: 'smooth',
    '&::-webkit-scrollbar': {
      width: theme.shape.scrollSize,
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: theme.palette.scroll,
      borderRadius: theme.shape.scrollRadius,
    },
  },
  loadingSection: {
    display: 'flex',
    justifyContent: 'center',
    padding: 15,
  },
  info: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: 15,
    borderRadius: theme.shape.borderRadius,
    border: `1px solid ${theme.palette.hover2}`,
  },
}))

export default useStyles
